export default {
  data() {
    return  {
      localizedMoods: [
        {
          key: 'Refreshed',
          value: 'message.moodRefreshed'
        },
        {
          key: 'Energetic',
          value: 'message.moodEnergetic'
        },
        {
          key: 'Focused',
          value: 'message.moodFocused'
        },
        {
          key: 'Restless',
          value: 'message.moodRestless'
        },
        {
          key: 'Calm',
          value: 'message.moodCalm'
        },
        {
          key: 'Distracted',
          value: 'message.moodDistracted'
        },
        {
          key: 'Fatigued',
          value: 'message.moodFatigued'
        },
        {
          key: 'Sleepy',
          value: 'message.moodSleepy'
        },
        {
          key: 'Weak',
          value: 'message.moodWeak'
        },
        {
          key: 'Anxious',
          value: 'message.moodAnxious'
        },
        {
          key: 'Chilled',
          value: 'message.moodChilled'
        },
        {
          key: 'Relieved',
          value: 'message.moodRelieved'
        },
        {
          key: 'Happy',
          value: 'message.moodHappy'
        },
        {
          key: 'Content',
          value: 'message.moodContent'
        },
        {
          key:'Excited',
          value: 'message.moodExcited'
        },
        {
          key: 'Stressed',
          value: 'message.moodStressed'
        },
        {
          key: 'Irritable',
          value: 'message.moodIrritable'
        },
        {
          key: 'Hopeless',
          value: 'message.moodHopeless'
        },
        {
          key: 'Angry',
          value: 'message.moodAngry'
        },
        {
          key: 'Worried',
          value: 'message.moodWorried'
        },
        {
          key: 'Unwell',
          value: 'message.moodUnwell'
        },
        {
          key: 'Dizzy',
          value: 'message.moodDizzy'
        },
        {
          key: 'Headache',
          value: 'message.moodHeadache'
        },
        {
          key: 'Hypo',
          value: 'message.moodHypo'
        },
        {
          key: 'Pain',
          value: 'message.moodPain'
        }
      ]
    }
  },
  methods: {
    localizeMood(key) {
      let self = this;
      return self.localizedMoods.filter(function (item) {
        return item.key === key;
      })[0].value;
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/Localization/Moods/MoodLocalizerMixin.js